<!--
 * @Author: caoyingming 1046659469@qq.com
 * @Date: 2022-07-19 14:14:19
 * @LastEditors: caoyingming 1046659469@qq.com
 * @LastEditTime: 2022-07-22 17:10:59
 * @FilePath: /genetron-web/genetron-h5/src/components/template/reportIndex825/components/geneChildFx copy.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="oneClass" ref="oneClass">
    <div class="wrap-data" v-for="(item, index) in dataList" :key="index">
      <div class="border">
        <h1 @click="wdDetails(item)">{{ item.geneName }}</h1>
        <div class="Target">
          <h2>检测结果</h2>
          <div class="Target-list">
            <!-- <p v-for="(i, index) in item.sensitivityDrugs" :key="index">
              {{ i }}
            </p> -->
            <div @click="wdClick(item)" class="result">
              <p>{{ item.cdnaChange }}</p>
              <p>{{ item.proteinChangeShort }}</p>
              <p>{{ item.exon }}</p>
              <p>{{ item.variantClassificationChinese }}</p>
            </div>
          </div>
        </div>
        <div class="Circle">
          <p>{{ item.variantType === "cnv" ? "拷贝数：" : "突变频率：" }}</p>
          <h3 v-if="item.variantType === 'cnv'">{{ item.vaf }}</h3>
          <div v-else>
            <van-circle
              v-model="item.currentRate"
              color="#4B84FF"
              layer-color="#ffffff"
              :rate="item.currentRate"
              :stroke-width="100"
              :text="item.vaf + '%'"
            />
          </div>
        </div>
        <div class="Target">
          <h2>可能获益靶药：</h2>
          <div class="Target-list">
            <p v-for="(i, index) in item.certainDrugsLevelList" :key="index">
              {{ i }}
            </p>
            <!-- <p>{{ item.certainDrugsLevel }}</p> -->
          </div>
          <div
            class="icon-box"
            v-if="$route.query.userAgent != 'wxWeb'"
            @click="handlePill(item)"
          >
            <!-- <i class="iconfont icon-yongyao"></i> -->
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-yongyao"></use>
            </svg>
            <!-- <div class="l"></div>
          <div class="r"></div> -->
          </div>
        </div>
        <div class="Target">
          <h2>可能耐药靶药：</h2>
          <div class="Target-list">
            <p v-for="(i, index) in item.resistanceDrugsLevelList" :key="index">
              {{ i }}
            </p>
          </div>
        </div>

        <!-- <div class="Target" v-if="tabVal == 1">
          <h2>相同变异患者：</h2>
          <div class="Target-list">
            <p style="color: #4b84ff">6/20</p>
          </div>
        </div> -->
      </div>

      <!-- <div class="btn">
      <div class="ts-info" @click="isNotes">
        <span>!</span>
        注释
      </div>
      <button @click="handleDetails('variationDetails')">
        检测结果详情<i class="iconfont icon-right_medium"></i>
      </button>
    </div> -->
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import isiOS from "@/utils/iosAn";

export default {
  props: {
    dataList: {
      type: Array,
    },
    tabVal: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      notesText: {
        h1: "",
        p: "",
      },
      isShow: false,
      wrapData: [],
      currentRate: 0,
      TargetList: [],
      ocdata: "",
      type: {
        name: "variationDetails",
        id: 12,
      },
    };
  },
  created() {
    window.NativeCallJS = (res) => {
      this.native(res);
    };
  },
  mounted() {},
  methods: {
    wdClick(item) {
      console.log(item);
      let param = {
        name: "wdJiedu",
        type: "1",
        gene: item.variation,
        // proteinChange: "-" + item.proteinChangeShort,
        proteinChange: "",
        tabIndex: "2",
        fromSource: "snv",
        cancerTwo: item.cancerTwo,
        productCode: item.productCode,
      };
      if (this.$route.query.userAgent == "wxWeb") {
        wx.miniProgram.navigateTo({
          url:
            "/packageWebView/pages/site-jiedu/site-jiedu?site=" +
            item.proteinChange,
        });
      } else if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    handlePill(item) {
      console.log(item.sensitivityDrugs);
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({
          name: "pill",
          gene: item.variation,
          arrList: item.sensitivityDrugs,
        });
      } else {
        window.android.JSCallNative(
          JSON.stringify({
            name: "pill",
            gene: item.variation,
            type: "",
            arrList: item.sensitivityDrugs,
          })
        );
      }
    },
    appSource() {
      if (isiOS) {
        console.log("ios");
        return "ios";
      } else {
        console.log("andriod");
        return "andriod";
      }
    },
    native(res) {
      Toast(res);
    },
    // 点击跳转详情
    handleDetails(name) {
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({ name: name });
      } else {
        window.android.JSCallNative(JSON.stringify({ name: name, type: "" }));
      }
      // this.$router.push({
      //   name: "variationDetails",
      //   query: {
      //     sessionId: this.$route.query.sessionId,
      //   },
      // });

      // window.webkit.messageHandlers.JSCallNative.postMessage(this.type);
    },
    wdDetails(item) {
      console.log(item);
      let param = {
        name: "wdJiedu",
        type: "1",
        wdName: item.variation,
        gene: "",
        proteinChange: item.variation,
        tabIndex: "2",
        variantType: item.variantType,
        webId: "BGXQ-825",
      };
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    isNotes() {
      this.notesText = {
        h1: "遗传易感相关变异注释1122",
        p: "克唑替尼*+雷莫芦单抗/贝伐",
      };
      this.$refs.child.ishow();
    },
  },
};
</script>
<style lang="less" scoped>
.oneClass {
  .btn {
    text-align: center;
    display: flex;
    justify-content: center;
    margin-top: 10px;
    button {
      width: 136px;
      height: 32px;
      background: linear-gradient(270deg, #60adff 0%, #4b84ff 100%);
      box-shadow: 0px 4px 10px 0px rgba(75, 132, 255, 0.2);
      border-radius: 16px;
      outline: none;
      border: 0;
      font-size: 12px;
      font-family: @family;
      font-weight: 400;
      color: #ffffff;
      margin-left: 12px;
      i {
        font-size: 10px;
      }
    }
  }

  .ts-info {
    width: 80px;
    height: 32px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(52, 68, 132, 0.08);
    border-radius: 16px;
    text-align: center;
    line-height: 32px;
    span {
      display: inline-block;
      width: 14px;
      min-width: 14px;
      height: 14px;
      border-radius: 14px;
      background: #ffdb4d;
      text-align: center;
      line-height: 14px;
      font-weight: 500;
      font-size: 10px;
    }

    p {
      font-size: 12px;
      font-family: @family;
      font-weight: 400;
      color: #9095a7;
      line-height: 17px;
    }
  }

  .wrap-data {
    padding: 0 24px;
    &:last-child {
      .border {
        border: 0;
      }
    }
    .border {
      border-bottom: 1px solid #e3e5e8;
      // margin-bottom: 30px;
    }
    .Target {
      display: flex;
      justify-content: space-between;
      // border-bottom: 1px solid #e3e5e8;
      margin-bottom: 16px;
      .icon-box {
        width: 32px;
        min-width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 6px;
        border: 1px solid #f3f5f8;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 6px;
        .icon {
          width: 16px;
          height: 16px;
          fill: currentColor;
          overflow: hidden;
        }
      }

      .Target-list {
        width: 100%;
        min-width: 148px;
        text-align: left;
        padding-right: 20px;
        .result {
          p {
            color: #4b84ff;
          }
        }
        p {
          font-size: 13px;
          font-family: @family;
          font-weight: 400;
          color: #2F354D;

          line-height: 28px;
        }
      }

      h2 {
        min-width: 100px;
        font-size: 13px;
        font-family: @family;
        font-weight: 400;
        color: #a4a9bf;
        line-height: 28px;
      }
    }

    .Circle {
      margin-bottom: 16px;
      display: flex;
      h3 {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2f354d;
        line-height: 28px;
      }
      /deep/.van-circle {
        width: 52px;
        height: 52px;
        .van-circle__text {
          font-size: 12px;
          font-weight: normal;
          color: #2f354d;
        }
      }

      p {
        min-width: 100px;
        font-size: 13px;
        font-family: @family;
        font-weight: 400;
        color: #a4a9bf;
        line-height: 28px;
      }
    }

    h1 {
      font-size: 15px;
      font-weight: 500;
      color: #4b84ff;
      line-height: 22px;
      position: relative;
      padding-left: 12px;
      margin-bottom: 20px;
      margin-top: 10px;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 10px;
        margin-top: -7px;
        width: 3px;
        height: 14px;
        background: #4b84ff;
        border-radius: 2px;
      }
    }
  }
}
</style>
